import request from '@/axios/http'


// 获取技巧师用户信息
export function getSkillerUserinfo (params) {
	return request({
		url: '/stage-api/lottery/technician/identity?userId=' + params,
		method: 'get',
	})
}

// 缩水单冠王
export function championList (params) {
	return request({
		url: '/stage-api/pre/champion/list' + params,
		method: 'get',
	})
}

// 根据字典类型查询字典数据信息
export function preDictType (data) {
	return request({
		url: '/stage-api/pre/dict/type/' + data,
		method: 'get',
	})
}

// 筛选期数条件
export function championQuery (data) {
	return request({
		url: '/stage-api/pre/champion/query/' + data,
		method: 'get',
	})
}

// 筛选价格查询条件
export function championCriteria (data) {
	return request({
		url: '/stage-api/pre/champion/criteria/' + data,
		method: 'get',
	})
}
